import { render, staticRenderFns } from "./CutSpritesBackgrounds.vue?vue&type=template&id=0b5c0bf6&scoped=true&"
import script from "./CutSpritesBackgrounds.vue?vue&type=script&lang=js&"
export * from "./CutSpritesBackgrounds.vue?vue&type=script&lang=js&"
import style0 from "./CutSpritesBackgrounds.vue?vue&type=style&index=0&id=0b5c0bf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5c0bf6",
  null
  
)

export default component.exports